<template>
  <div class="card modal-card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('ajoutEditContrat.echeancier.popupPayer.title',
            { montantEcheance: montantAPayer,
              mode: modeReglementLibelle,
              tiers: tiersLibelle}) }}
          </h1><br />
          <h3>
            {{ $t('ajoutEditContrat.echeancier.popupPayer.periode',
            { debut : formatPeriode(dateDebut),
              fin : formatPeriode(dateFin)}) }}
          </h3>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                               :messagesChampsVide="messagesChampsVide"
                               :champsVide="champsVide"
                               :error="error"
                               :title="'addEditCivilite.error.problemOccurred'"
                               :withEmplyFields="true"
                               @close="error = $event"/>
        <b-field class="obligatoire"
        :label="$t('ajoutEditContrat.echeancier.popupPayer.libelle')">
          <b-input v-model="libelleLot"></b-input>
        </b-field>
        <b-field :label="$t('ajoutEditContrat.echeancier.popupPayer.datePaiement')"
                  class="obligatoire">
          <b-datepicker show-week-number
                        icon="calendar-today"
                        :editable="true"
                        position="is-bottom-left"
                        v-model="dateRemise"
                        :nearby-selectable-month-days="true">
          </b-datepicker>
        </b-field>
        <b-field :label="$t('ajoutEditContrat.echeancier.popupPayer.domiciliation')"
                  class="obligatoire">
          <b-select v-model="domiciliationBancaireId" expanded>
            <option v-for="domiciliation in domBancaires"
                    :value="domiciliation.id" :key="domiciliation.id">
              {{domiciliation.libelleBanque}} ({{ domiciliation.libelle }})
            </option>
          </b-select>
        </b-field>
        <b-field :label="$t('ajoutEditContrat.echeancier.popupPayer.numero')">
          <b-input v-model="numero"></b-input>
        </b-field>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="createLotPaiement">
                {{ $t('ajoutEditContrat.echeancier.popupPayer.actions.payer')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';
import formatIsoDate from '@/services/general/formatIsoDate';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { generationPaiementUnitaire } from '@/api/factureAchat';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/validation/validation';
import validationEcheanceAPayer from '@/services/baux/echeancesAPayer/validationEcheanceAPayer';
import translate from '@/services/baux/echeancesAPayer/translatorEcheancesAPayer';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popupPayer',
  components: {
    errorMsgComponent,
  },
  props: {
    devisCommandeId: {
      type: String,
      required: true,
    },
    modeReglementId: {
      type: String,
      required: true,
    },
    modeReglementLibelle: {
      type: String,
      required: true,
    },
    dateEcheance: {
      type: Date,
      required: true,
    },
    dateDebut: {
      type: Date,
      required: true,
    },
    dateFin: {
      type: Date,
      required: true,
    },
    montantAPayer: {
      type: Number,
      required: true,
    },
    tiersId: {
      type: String,
      required: true,
    },
    tiersLibelle: {
      type: String,
      required: true,
    },
    contratCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      libelleLot: '',
      dateRemise: new Date(),
      domiciliationBancaireId: null,
      domBancaires: [],
      numero: '',
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    formatPeriode(date) {
      return formatDate(date);
    },
    loadDomiciliationBancaire() {
      const domBancairesIds = this.parametre(
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ).filter((domicialisation) => {
        return domicialisation.actif;
      });

      return domBancairesIds;
    },
    async createLotPaiement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const param = {
          commandeId: this.devisCommandeId,
          domiciliationBancaireId: this.domiciliationBancaireId,
          modeReglementId: this.modeReglementId,
          dateReglement: formatIsoDate(this.dateRemise),
          libelle: this.libelleLot,
          numeroPaiement: this.numero,
        };
        await generationPaiementUnitaire(param);
        loadingComponent.close();
        messageSuccess(this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.successPayer'));
        this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationEcheanceAPayer(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.libelleLot = this.$i18n.t('ajoutEditContrat.echeancier.popupPayer.libelleLot', {
        echeance: this.formatPeriode(this.dateEcheance),
        code: this.contratCode,
        tiers: this.tiersLibelle,
      });
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ]);
      this.domBancaires = this.loadDomiciliationBancaire();
      if (this.domBancaires.length === 1) this.domiciliationBancaireId = this.domBancaires[0].id;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
